module.exports = __webpack_public_path__ + "static/media/inc_outside_india_myway.d27d02ee.svg";